var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{staticClass:"loading-overlay"},[_c('img',{key:_vm.gifKey,attrs:{"src":_vm.gifSrcWithTs,"alt":"Loading..."}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }